import { SetToastFunc } from 'types/toast';
import React from 'react';

const ToastContext = React.createContext<SetToastFunc | null>(null);

export default ToastContext;
